import AboutUsLayout from "@app/layouts/AboutUs/AboutUsLayout";
import ErrorLayout from "@app/layouts/ErrorLayout/ErrorLayout";
import { StaticContent } from "@app/types/ServerCustomContext";
import MetaData from "@components/Modules/MetaData";
import {
  mapErrorDataToMetaData,
  mapStaticContentDataToMetaData,
} from "@components/Modules/MetaData/mappers";
import PubBaseLayout from "@pub/BaseLayout";
import { Route } from "@route-types/AboutUs/+types/AboutUs";
import { GlobalBaseData } from "@sphtech/dmg-design-system";
import {
  ResponseType,
  TRouteWithoutRedirect,
  TRouteWithRedirect,
} from "@sphtech/web2-core/ssr";
import { dataLoader } from "@src/app/utils/dataLoader";
import { ReactNode } from "react";
import { useLoaderData } from "react-router";

import { fetchAboutUsData } from "./AboutUs.server";

export const meta = ({
  loaderData,
  location,
}: {
  loaderData: TRouteWithRedirect<StaticContent, string>;
  location: { pathname: string };
}) => {
  if (loaderData.type !== ResponseType.SUCCESS) {
    const errorData = mapErrorDataToMetaData(loaderData, location);
    return MetaData(errorData);
  }

  const metaData = mapStaticContentDataToMetaData(loaderData.payload);

  return MetaData({ ...metaData, type: "WebPage" });
};

export default function AboutUsPage(): ReactNode {
  const response: TRouteWithoutRedirect<StaticContent, string> =
    useLoaderData();

  if (response.type !== ResponseType.SUCCESS) {
    return <ErrorLayout response={response} />;
  }

  const { processedElements, path, displaySetting } = response.payload;
  const { headline, headlineZH, standfirst, coverImage, bodyElements } =
    processedElements;

  return (
    <PubBaseLayout ads={false}>
      <AboutUsLayout
        headline={headline}
        headlineZH={headlineZH}
        standfirst={standfirst}
        coverImage={coverImage}
        bodyElements={bodyElements}
        path={path}
        displaySetting={displaySetting}
      />
    </PubBaseLayout>
  );
}

export async function loader({
  request,
}: Route.LoaderArgs): Promise<
  TRouteWithRedirect<StaticContent | GlobalBaseData, GlobalBaseData | string>
> {
  const data = await fetchAboutUsData(request.url);

  return await dataLoader({
    type: data.type,
    dataSource: data,
  });
}
